export default __webpack_public_path__ + "static/media/1463.9c3824a2.png";